exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "div.companyMatch{display:inline-block}div.companyMatch .selectButton{float:right;padding:0 0 30px}div.companyMatch .business-card{display:inline-block}", ""]);

// exports
